import { render, staticRenderFns } from "./TargetUri.vue?vue&type=template&id=beb172b8&"
import script from "./TargetUri.vue?vue&type=script&lang=js&"
export * from "./TargetUri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports